import { clearQuotes } from './spchars';
import { clone } from './tools';
import { styleCb } from '../css';

export class State {
  constructor(init) {
    Object.assign(this, init, {
      dom: [], stack: [], i0: 0, fn: [], fncnt: 0, funcs: {}, styleCb,
    });
  }

  writeText(str, i) {
    let txt;
    if (i) txt = str.substring(this.i0, i);
    else txt = str.substr(this.i0);
    this.log(txt);
  }

  log(o, ...a) {
    if (o.type !== 'b' && !this.findOpen('b')) {
      this.startTag('p', null, { type: 'b' });
    }
    this.stack.unshift(o);
    // console.log(o, a);
  }

  xMode() {
    if (this.findOpen('b', 'bc', true)
      || this.findOpen('i', 'code')
      || this.findOpen('i', 'inotex')
      || this.findOpen('b', 'notextile', true)
      || this.findOpen('b', 'style', true)) {
      return 1;
    }
  }

  safeParm(key, defval = '') {
    if (this.parms) return this.parms[key];
    else return defval;
  }

  startTag(tag, attrs, extProps) {
    for (const x in attrs) if (!attrs[x]) delete attrs[x];
    attrs = Object.assign({}, attrs, { iTex: this.safeParm('i', -1) });
    const tobj = { tag, attrs, children: [], open: true };
    if (extProps) Object.assign(tobj, extProps);
    this.log(tobj);
    return tobj;
  }

  findOpen(type, tag, hardOpen) {
    return this.stack.find(cbFilter(type, tag, hardOpen));
  }

  findIdx(type, tag, hardOpen) {
    return this.stack.findIndex(cbFilter(type, tag, hardOpen));
  }

  findAll(type, tag, hardOpen) {
    return this.stack.filter(cbFilter(type, tag, hardOpen));
  }

  handleCb(el, txt) {
    const tag = el?.tag ?? el;
    if (typeof tag !== 'string') return;
    const cb = this[tag + 'Cb'];
    if (typeof cb !== 'function') return;
    return cb(el, txt, this);
  }

  closeProps(el) {
    for (const x of ['open', 'alt', 'type', 'hardOpen', 'deep']) {
      delete el[x];
    }
  }

  closeTag(type, tag, hardOpen) {
    let closer = type;
    if (type === 'b' && (!tag || typeof tag === 'number')) {
      // these can be several 'b' tags deep, close all
      closer = this.findAll(type, tag, hardOpen);
      // }
      for (const el of closer) this.closeTag(el);
      return;
    }
    if (typeof closer === 'string') closer = this.findOpen(type, tag, hardOpen);
    if (!closer) return false;
    if (typeof type !== 'string') type = closer.type;
    if (type === 'b') clearQuotes(this);

    while (true) {
      let s = this.stack.shift();
      if (s === closer) break;
      if (s.open && !s.deep) s = s.alt || '';
      this.closeProps(s);
      unshiftc(closer.children, s);
    }
    this.handleCb(closer, null, this);
    this.closeProps(closer);
    if (closer.fn) {
      this.fn.push(closer);
    } else if (this.stack.length) {
      this.stack.unshift(closer);
    } else if (closer.tag === 'style') {
      this.dom.unshift(closer);
    } else if (closer.tag === 'script' && closer.attrs.id) {
      // eslint-disable-next-line no-new-func
      this.funcs[closer.attrs.id] = new Function(
        closer.attrs.class || '',
        closer.children.join('\n')).bind(this);
    } else {
      this.dom.push(closer);
    }
    return true;
  }

  altTag(type, tag, hardOpen) {
    const cbClose = cbFilter(type, tag, hardOpen);
    this.stack = this.stack.map(x => {
      if (cbClose(x)) return x.alt || '';
      else return x;
    });
  }

  cloneTag(id) {
    const ff = i => x => x.attrs && x.attrs.id === i;
    let itex = this.safeParm('i', -1);
    const cc = (el, i = 0) => clone({}, el,
      { attrs: { id: id + '-clone-' + (this.dom.length + i), iTex: itex++ } });
    const el = this.dom.find(ff(id));
    if (el) this.dom.push(cc(el));
    else {
      const i0 = this.dom.findIndex(ff(id + '0'));
      const i1 = this.dom.findIndex(ff(id + '1'));
      if (i0 >= 0 && i1 >= 0) {
        this.dom.push(
          ...this.dom.slice(i0, i1 + 1).map((x, i) => cc(x, i)),
        );
      }
    }
  }

  end() {
    /* eslint-disable-next-line no-empty */
    while (this.closeTag('b', null, true)) { }
  }
}

function cbFilter(type, tag, hardOpen) {
  return x => x.open
    && ((!type && x.type) || x.type === type)
    && (!tag
      || (tag instanceof RegExp && tag.test(x.tag))
      || (typeof tag === 'number' && x.deep >= tag)
      || (x.tag === tag)
    )
    && (hardOpen || !x.hardOpen);
}

function unshiftc(arr, item) {
  if (typeof item === 'string' && arr.length
    && typeof arr[0] === 'string') arr[0] = item + arr[0];
  else arr.unshift(item);
}
